import { eDocScene } from '../document.baseType';
import { iDocRouteData } from './docRoute.type';

import { docRouteEffects, docRouteReducers } from './docRoute.operator';

// DocRoute 初始状态
const docRouteInitData: iDocRouteData = {
  // 业务数据
  routeDocId: '',
  routeScene: eDocScene.unknown,
  // 路由链接数据
  routeParams: {},
  routeFullPath: '',
};

// Model
export const docRouteModel = {
  state: docRouteInitData,
  reducers: docRouteReducers,
  effects: docRouteEffects,
};
